import { render, staticRenderFns } from "./modal-documents-send.vue?vue&type=template&id=8bd90cce&scoped=true"
import script from "./modal-documents-send.vue?vue&type=script&lang=js"
export * from "./modal-documents-send.vue?vue&type=script&lang=js"
import style0 from "./modal-documents-send.vue?vue&type=style&index=0&id=8bd90cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd90cce",
  null
  
)

export default component.exports